export const commentsRe =  /\/\*(?:[\s\S]+?)\*\//g
export const inlineCommentsRe = /\/\/(.+)/gm